import React, { Component } from 'react';
import { FormControl, InputLabel, ListSubheader, MenuItem, Select } from '@mui/material';
import Hidden from '../Hidden';
import FormHelperText from '@mui/material/FormHelperText';
import withStyles from '@mui/styles/withStyles';
import { getElementValueWrapper, isNullOrUndefined, onChangeWrapper } from '../../utils/objects';
import { getValidationDecorations } from '../../utils/validation';
import ReadonlyField from './ReadonlyField';

// This wraps the Select component to render either a
// native select or stylized select depending on breakpoints
class CustomSelect extends Component {
    render() {
        let {
            className,
            fullWidth = true,
            id,
            name,
            label,
            options,
            placeholder,
            controlProps,
            labelProps,
            selectProps,
            optionProps,
            menuItemProps,
            valueField,
            disabled,
            required,
            title,
            readOnly,
            helperText,
            allowNone = true
        } = this.props;

        id = id || (name ? `choose-${name}` : undefined);
        const inputProps = { id, name };
        if (selectProps && selectProps.inputProps) Object.assign(inputProps, selectProps.inputProps);

        let value = getElementValueWrapper(this);

        const decorations = getValidationDecorations(this.props);

        const commonSelectProps = {
            ...selectProps,
            value,
            onChange: e => onChangeWrapper(e, this),
            inputProps,
            //className: 'control',
            classes: { select: 'control' },
            placeholder,
            displayEmpty: true,
            className: `outer-control ${className || ''}`
        };

        if (readOnly) {
            const formValue = (options.find(e => e.value === value) || {}).label || value;
            return <ReadonlyField label={label} validationClass={decorations.cssClass}>{formValue}</ReadonlyField>;
        }

        return (
            <span className={`select input ${!!fullWidth ? 'select--fullwidth' : ''} ${decorations.cssClass}`}>
                <FormControl
                    {...controlProps}
                    required={required}
                    disabled={disabled}
                    readOnly={readOnly}
                    fullWidth
                    title={title}
                >
                    {label && (
                        <InputLabel
                            {...labelProps}
                            shrink
                            htmlFor={id}
                            className="label"
                            classes={{ shrink: `label--shrink ${decorations.cssClass}` }}
                        >
                            {decorations.validationIcon}
                            <span className="label-text">{label}</span>
                        </InputLabel>
                    )}
                    <Hidden smUp>
                        <Select {...commonSelectProps} native>
                            {allowNone ? <option value="">{placeholder || 'Please select...'}</option> : ''}
                            {(options ?? [])
                                .map((opt, idx) => {
                                    const menuItem = (o, i) => (
                                        <option
                                            {...optionProps}
                                            key={i}
                                            value={(valueField ? o[valueField] : o.value) || ''}
                                            disabled={o.disabled}
                                        >
                                            {o.label}
                                        </option>
                                    );
                                    return opt.options ? (
                                        <optgroup key={idx} label={opt.label}>
                                            {!isNullOrUndefined(opt.value) ? menuItem(opt, idx) : null}
                                            {opt.options.map((o, i) => menuItem(o, idx + '-' + i))}
                                        </optgroup>
                                    ) : (
                                        menuItem(opt, idx)
                                    );
                                })}
                        </Select>
                    </Hidden>
                    <Hidden smDown>
                        <Select {...commonSelectProps}>
                            {allowNone ? (
                                <MenuItem {...menuItemProps} value="">
                                    {placeholder || 'Please select...'}
                                </MenuItem>
                            ) : null}
                            {(options ?? [])
                                .map((opt, idx) => {
                                    const menuItem = (o, i, isSub = false) => (
                                        <MenuItem {...menuItemProps} key={i} disabled={o.disabled}
                                                  value={(valueField ? o[valueField] : o.value) || ''}>
                                            <div style={!isSub ? null : ({ fontSize: '90%', marginLeft: 12 })}>
                                                {o.label}
                                            </div>
                                        </MenuItem>
                                    );
                                    return opt.options ? [
                                        !isNullOrUndefined(opt.value) ? (menuItem(opt, idx)) : (
                                            <ListSubheader>{opt.label}</ListSubheader>),
                                        opt.options.map((o, i) => menuItem(o, idx + '-' + i, true))
                                    ] : menuItem(opt, idx);
                                })}
                        </Select>
                    </Hidden>
                    {(decorations.errorMsg || !!helperText) && (
                        <FormHelperText
                            error={decorations.inError}
                            classes={{
                                error: `validation-label ${decorations.cssClass}`
                            }}
                        >
                            {decorations.errorMsg || helperText}
                        </FormHelperText>
                    )}
                </FormControl>
            </span>
        );
    }
}

CustomSelect.defaultProps = {
    fullWidth: true,
    emptyValue: ''
};

export default withStyles({})(CustomSelect);
